var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fade-transition',{attrs:{"duration":{enter: 500, leave: 10},"mode":"out-in","appear":""}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }